import { createSlice } from "@reduxjs/toolkit";
import { GetChalanNames } from "services/dropdown/dropdown.service";
import { toast } from 'react-toastify';

export const chalanNamesSlice = createSlice({
    name: "chalanNames",
    initialState: {
        chalanNames: [],
        chalanNamesLoading: false,
        chalanNamesError: null,
    },
    reducers: {},
    extraReducers: 
    (builder) => {
      builder.addCase(GetChalanNames.pending, (state) => {
        state.chalanNamesLoading = true
      });
  
      builder.addCase(GetChalanNames.fulfilled, (state, action) => {
        toast.dismiss();
        // toast.success('Promise resolved for chalam name list👌');
  
        state.chalanNames = action.payload
        state.chalanNamesLoading = false
        state.chalanNamesError = null
      });
  
      builder.addCase(GetChalanNames.rejected, (state, action) => {
        toast.dismiss();
        toast.error('Promise rejected for chalam name list🤯 😣')
  
        state.chalanNamesLoading = false
        state.chalanNamesError = action.error?.message
      });
    },
  });

export default chalanNamesSlice.reducer;
